import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'tellent-assistant-thinking-indicator',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </span>
    <span class="label">{{ 'tlc.tellent_assistant.thinking_indicator.label' | translate }}</span>
  `,
  styleUrls: ['./tellent-assistant-thinking-indicator.component.less'],
})
export class TellentAssistantThinkingIndicatorComponent {}
